var _path, _path2, _rect, _g, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 49C38.9264 49 49 38.9264 49 26.5C49 14.0736 38.9264 4 26.5 4C14.0736 4 4 14.0736 4 26.5C4 38.9264 14.0736 49 26.5 49ZM26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5258 27.8109L39.9944 27.439C40.8613 27.2195 41.5 26.4312 41.5 25.5C41.5 24.4611 40.706 23.6048 39.6935 23.5091L38.1868 23.3666L37.6144 21.9656C35.8237 17.5817 31.5187 14.5 26.5 14.5C21.4813 14.5 17.1763 17.5817 15.3856 21.9656L14.8132 23.3666L13.3065 23.5091C12.294 23.6048 11.5 24.4611 11.5 25.5C11.5 26.4312 12.1387 27.2195 13.0056 27.439L14.4742 27.8109L14.8242 29.285C16.0793 34.5704 20.8338 38.5 26.5 38.5C32.1662 38.5 36.9207 34.5704 38.1758 29.285L38.5258 27.8109ZM12.3919 29.8625C13.9084 36.2492 19.6494 41 26.5 41C33.3506 41 39.0916 36.2492 40.6081 29.8625C42.5576 29.3689 44 27.6029 44 25.5C44 23.1593 42.2129 21.2361 39.9288 21.0202C37.7673 15.7287 32.5691 12 26.5 12C20.4309 12 15.2327 15.7287 13.0712 21.0202C10.7871 21.2361 9 23.1593 9 25.5C9 27.6029 10.4424 29.3689 12.3919 29.8625Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1175_6774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 29,
    width: 19,
    height: 7
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29,
    width: 19,
    height: 7,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1175_6774)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 33.5C30.366 33.5 33.5 30.366 33.5 26.5C33.5 22.634 30.366 19.5 26.5 19.5C22.634 19.5 19.5 22.634 19.5 26.5C19.5 30.366 22.634 33.5 26.5 33.5ZM26.5 36C31.7467 36 36 31.7467 36 26.5C36 21.2533 31.7467 17 26.5 17C21.2533 17 17 21.2533 17 26.5C17 31.7467 21.2533 36 26.5 36Z",
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 22.5,
    r: 2.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 22.5,
    r: 2.5,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChild);
export default __webpack_public_path__ + "static/media/iconChild.e4c5d7eda9752af75e925e0ed1096e0a.svg";
export { ForwardRef as ReactComponent };